import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initSentry } from './lib/sentry';
import { initI18n } from './i18n';
import './styles.css';

initSentry();
initI18n();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error("Root element with id 'root' not found");

createRoot(rootElement).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
